import { combineReducers } from '@reduxjs/toolkit';
import { cardsReducer, demoCardsReducer } from './cards';
import { paymentMethodsReducer } from './paymentMethods';

export const domainReducer = combineReducers({
  cards: cardsReducer,
  demoCards: demoCardsReducer,
  paymentMethods: paymentMethodsReducer,
});
